import React, { useState, useEffect } from 'react';

import eduKidGoggles from '../../../main/assets/images/skydive/education-enterprise-kid-goggles.webp';

export const EduEnterprise = () => {
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      const mediaQuery = window.matchMedia('(max-width: 767px)');
      setIsSmallScreen(mediaQuery.matches);
    };

    checkScreenSize();

    const mediaQueryList = window.matchMedia('(max-width: 767px)');
    mediaQueryList.addEventListener('change', checkScreenSize);

    return () => {
      mediaQueryList.removeEventListener('change', checkScreenSize);
    };
  }, []);

  if (isSmallScreen) {
    return (
      <section className="skydive-edu-section-mobile">
        <div className="skydive-edu-content-layout-mobile">
          <h2 className="skydive-edu-title-mobile">
            <span style={{ whiteSpace: 'nowrap', display: 'block' }}>
              EDUCATIONAL &
            </span>
            <span style={{ whiteSpace: 'nowrap', display: 'block' }}>
              {' '}
              ENTERPRISE USE
            </span>
          </h2>
          <p className="skydive-edu-description-mobile">
            Our standalone solution is fully independent, offering
            white-labeled, tailored systems with customizable content. It meets
            industry-specific requirements and is ideal for educational use,
            available on both Windows and MacOS.
          </p>
          <div className="dreamX__discover--button">
            <a
              href="/contact?product=skydive"
              target="_blank"
              className="btn btn--primary btn--med"
              onMouseDown={event => event.preventDefault()}
            >
              GET IN TOUCH
            </a>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="sykdive-edu-section">
      <div className="skydive-edu-text-container">
        <div className="skydive-edu-polygon">
          <div className="skydive-edu-content-layout">
            <div className="skydive-edu-text-section">
              <h2 className="skydive-edu-title">
                <span style={{ whiteSpace: 'nowrap', display: 'block' }}>
                  EDUCATIONAL &
                </span>
                <span style={{ whiteSpace: 'nowrap', display: 'block' }}>
                  {' '}
                  ENTERPRISE USE
                </span>
              </h2>
              <p className="skydive-edu-description">
                Our standalone solution is fully independent, offering
                white-labeled, tailored systems with customizable content. It
                meets industry-specific requirements and is ideal for
                educational use, available on both Windows and MacOS.
              </p>
            </div>
            <div className="dreamX__discover--button">
              <a
                href="/contact?product=skydive"
                target="_blank"
                className="btn btn--primary btn--med"
                onMouseDown={event => event.preventDefault()}
              >
                GET IN TOUCH
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="skydive-edu-image-container">
        <img
          src={eduKidGoggles}
          alt="Child Learning Goggle Use"
          className="skydive-edu-main-image"
        />
      </div>
      <div className="skydive-edu-bg-effect" />
    </section>
  );
};
